// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__FxLjO","child1":"style_child1__c8jiU","child2":"style_child2__yxO7B","content":"style_content__PkRyO"};